import React, { useEffect, useMemo, useState } from "react";
import { Container } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Row } from "reactstrap";
import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
import { fetchNodeData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import { numberToWords } from "utils/common-helpers";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import configure from "configure";

const ViewZtplInvoice = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const token = secureLocalStorage.getItem("auth_token");
  useEffect(() => window.scrollTo(0, 0), []);
  const contentRef = useRef(null);

  const [formatData, setFormatData] = useState({
    companyName: "",
    address: "",
    tnc: "",
    bankName: "",
    branchName: "",
    accountName: "",
    accountNo: "",
    ifscCode: "",
    bankAddress: ""
  })
  const [lutList, setLutList] = useState([])


  // LOAD DATA
  const loadLut = async () => {
    const res = await fetchNodeData(null, "invoiceDetails/lut", token)
    if (res?.success) {
      const formatted = res.data.map(i => {
        const [start, end] = i.financial_year.split('-')
        return ({
          start: `${start}-04-01`,
          end: `${end}-03-31`,
          lut: i.lut_number,
        })
      })
      console.log("formatted", formatted)
      setLutList(formatted)
    }
  }

  useEffect(() => {
    loadLut()
    document.title = "View Invoice | Zithas Crm";
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchNodeData(
        setLoading,
        `invoiceDetails/getByCountry/${invoiceData?.location}`,
        token
      )

      if (res?.success && res.data) {
        const data = res.data

        setFormatData({
          companyName: data.company_name || "",
          address: data.address || "",
          tnc: data.tnc || "",
          bankName: data.bank_name || "N/A",
          branchName: data.branch_name || "N/A",
          accountName: data.account_name || "N/A",
          accountNo: data.account_no || "N/A",
          ifscCode: data.ifsc_code || "N/A",
          bankAddress: data.bank_address || "N/A",
        })
      }
    }
    if (invoiceData?.location) fetchData()
  }, [invoiceData])


  useEffect(() => {
    const getInvoiceDetail = async () => {
      const res = await fetchNodeData(
        setLoading,
        `ztplPerformaIndex/view/${params?.id}`
      );
      if (res?.status == 200) {
        console.log(res);
        setInvoiceData(res?.data);
      }
    };
    getInvoiceDetail();
  }, []);

  const reactToPrintFn = useReactToPrint({
    contentRef,
  });

  // const onDownloadInvoice = () => {
  //   setLoading(true);

  //   setTimeout(() => {
  //     const content = contentRef.current;
  //     const safeFileName = invoiceData?.tax_inv_no.replace(/\//g, "-");

  //     const opt = {
  //       filename: `${safeFileName}.pdf`,
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
  //       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //     };

  //     html2pdf()
  //       .from(content)
  //       .set(opt)
  //       .save()
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }, 150);
  // };


  const onDownloadPdf = async (
    setLoading,
    contentRef,
    letterType,
    margins = [5, 5, 10, 10],
  ) => {
    if (!contentRef?.current) return;

    setLoading(true);

    try {
      const fileName = `${letterType}.pdf`;
      const element = contentRef.current;
      const cloned = element.cloneNode(true);

      cloned.style.marginTop = "0px";

      const opt = {
        margin: margins,
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 4,
          letterRendering: true,
          dpi: 300,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["css"],
        },
      };

      const pdf = await html2pdf().from(cloned).set(opt).toPdf().get("pdf");

      // modify pages
      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 2; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.internal.pageSize.height += 20;
      }

      pdf.save(fileName);
    } catch (err) {
      console.error("PDF generation failed", err);
    } finally {
      setLoading(false); // ✅ always executed
    }
  };


  const getLutNumber = invoiceDate => {
    const date = new Date(invoiceDate)

    const match = lutList.find(item => {
      return date >= new Date(item.start) && date <= new Date(item.end)
    })

    return match ? match.lut : "N/A"
  }

  const lutNumber = useMemo(() => {
    if (invoiceData && lutList) {
      return getLutNumber(invoiceData?.tax_inv_date)
    } else {
      return 'N/A'
    }
  }, [lutList, invoiceData])

  const isIndia = useMemo(() => invoiceData?.location == 1, [invoiceData]);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className={"page-content mb-4"}>
        <Container fluid>
          <Row>
            <div className="col-md-9 ps-0 d-flex justify-content-center">
              <div id="zithasInvoicePrint" className="col-md-11 p-3 document">
                <div
                  className="invoice-view p-4 bg-white "
                  ref={contentRef}
                >
                  <div className="row justify-content-between">
                    <div className="col-4">
                      <img src={zithasLogo} className="img-fluid mt-2" alt="" />
                    </div>

                    {/* <div className="col-4 text-end">
                      <span>
                        Zithas Technologies Pvt. Ltd. <br />FF-16 Kalpvrux Complex,
                        <br />Opp. GEB Substation, Gotri Road <br />Vadodara Gujarat 390021
                        India <br /> GSTIN - 24AABCZ2004K1ZL <br />
                        LUT NO -  {getLutNumber(invoiceData?.tax_inv_no)}
                      </span>
                    </div> */}

                    <div className="col-4 text-end text-dark">
                      <div className="fw-semibold">{formatData?.companyName}</div>
                      <span style={{ fontSize: "small" }}>
                        <pre className="fs-6 mb-1" style={{ fontFamily: "Poppins", whiteSpace: 'pre-wrap' }}>{formatData?.address}</pre>
                        {isIndia && (
                          <div className="fw-semibold">
                            GSTIN - 24AABCZ2004K1ZL <br />
                            LUT NO - {lutNumber}
                          </div>
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-4 pe-0">
                      <div className="invoice-line"></div>
                    </div>
                    <div className="col-4">
                      <p className="fs-4 py-3 text-center bg-white mb-0 fw-bold">
                        TAX INVOICE
                      </p>
                    </div>
                    <div className="col-4 ps-0">
                      <div className="invoice-line"></div>
                    </div>
                  </div>

                  <div className="row justify-content-between">
                    <div className="col-4 ">
                      <p className="mb-0">Bill To</p>
                      <p className="mb-0">{invoiceData?.c_company} ,</p>
                      <p className="mb-0">
                        {invoiceData?.c_address},
                        {invoiceData?.city_name
                          ? ` ${invoiceData.city_name}, `
                          : ""}
                      </p>
                      <p className="mb-0">
                        {invoiceData?.state_name}, {invoiceData?.country_name} -{" "}
                        {invoiceData?.c_zipcode}
                      </p>
                      {invoiceData?.c_country == 1 ? (
                        <p className="mb-0">GST : {invoiceData?.c_vatnumber}</p>
                      ) : null}
                    </div>
                    <div className="col-4 ps-0">
                      <table
                        className="table w-100"
                        style={{ fontSize: "x-small" }}
                      >
                        <tbody>
                          <tr>
                            <th className="border border-secondary py-1">
                              Invoice#
                            </th>
                            <td className="border border-secondary py-1">
                              {invoiceData?.tax_inv_no}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Invoice Date
                            </th>
                            <td className="border border-secondary py-1">
                              {moment(invoiceData?.tax_inv_date).format(
                                "DD-MM-YYYY"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Terms
                            </th>
                            <td className="border border-secondary py-1">
                              {invoiceData?.terms}
                            </td>
                          </tr>
                          <tr>
                            <th className="border border-secondary py-1">
                              Due Date
                            </th>
                            <td className="border border-secondary py-1">
                              {moment(invoiceData?.due_date).format(
                                "DD-MM-YYYY"
                              )}
                            </td>
                          </tr>
                          {moment(invoiceData?.start_date)?.isValid() ? (
                            <tr>
                              <th className="border border-secondary py-1">
                                Start Date
                              </th>
                              <td className="border border-secondary py-1">
                                {moment(invoiceData?.start_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                            </tr>
                          ) : null}
                          {moment(invoiceData?.end_date)?.isValid() ? (
                            <tr>
                              <th className="border border-secondary py-1">
                                End Date
                              </th>
                              <td className="border border-secondary py-1">
                                {moment(invoiceData?.end_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="mt-4">
                    <table className="table w-100" style={{ pageBreakInside: "auto" }}>
                      <thead>
                        <tr style={{ pageBreakInside: "avoid" }}>
                          <th className="border border-secondary">#</th>
                          <th className="border border-secondary">
                            Item & Description
                          </th>
                          {configure.location.includes(1) && (
                            <th className="border border-secondary">HSN/SAC</th>
                          )}

                          <th className="border border-secondary">Qty</th>
                          <th className="border border-secondary" style={{ width: "15%" }}>Rate</th>
                          <th className="border border-secondary" style={{ width: "15%" }}>Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {invoiceData?.items?.map((obj, i) => {
                          return (
                            <tr key={i} style={{ pageBreakInside: "avoid" }}>
                              <td className="border border-secondary">
                                {i + 1}
                              </td>
                              <td className="border border-secondary">
                                <div className="">{obj?.project_name}</div>
                                <div className="">{obj?.service}</div>
                                <span>{obj?.service_detail}</span>
                              </td>
                              {configure.location.includes(1) && (
                                <td className="border border-secondary">
                                  {obj.hsn}
                                </td>
                              )}

                              <td className="border border-secondary">
                                {obj?.quantity}
                              </td>
                              <td className="border border-secondary">
                                {invoiceData?.currency_symbol} {obj?.rate}
                              </td>
                              <td className="border border-secondary">
                                {invoiceData?.currency_symbol}{" "}
                                {Number(obj?.rate) * Number(obj?.quantity)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: invoiceData?.customer_note,
                      }}
                    />
                  </div>

                  <div className="row justify-content-end">
                    <div className="col-5">
                      <div className="d-flex py-1 justify-content-between">
                        <span>Sub Total</span>
                        <span>
                          {invoiceData?.currency_symbol}{" "}
                          {Number(invoiceData?.sub_total || 0)?.toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex py-1 justify-content-between">
                        <span>Discount</span>
                        <span>{invoiceData?.currency_symbol}{" "}{invoiceData?.discount_amount || 0}</span>
                      </div>
                      {invoiceData?.c_state == 12 ? (
                        <>
                          <div className="d-flex py-1 justify-content-between">
                            <span>CGST (9%)</span>
                            <span>
                              {invoiceData?.currency_symbol} {Number(invoiceData?.cgst || 0)?.toFixed(2)}
                            </span>
                          </div>
                          <div className="d-flex py-1 pb-3 justify-content-between">
                            <span>SGST (9%)</span>
                            <span>
                              {invoiceData?.currency_symbol} {Number(invoiceData?.sgst || 0)?.toFixed(2)}
                            </span>
                          </div>
                        </>
                      ) : invoiceData?.c_country == 1 &&
                        invoiceData?.c_state != 12 ? (
                        <div className="d-flex pt-1 pb-3 justify-content-between">
                          <span>IGST (18%)</span>
                          <span>
                            {invoiceData?.currency_symbol} {Number(invoiceData?.igst || 0)?.toFixed(2)}
                          </span>
                        </div>
                      ) : null}
                      <div className="d-flex pt-2 border-top border-secondary pb-2 justify-content-between">
                        <strong> Total ({invoiceData?.currency_symbol})</strong>
                        <span>
                          {invoiceData?.currency_symbol}
                          {(Math.floor(parseFloat(invoiceData?.total || 0) * 100) / 100).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className=" row  pb-2">
                    <p>
                      Total in Words :{" "}
                      <strong>
                        {numberToWords(
                          invoiceData?.total || 0,
                          invoiceData?.currency_name
                        )}
                      </strong>
                    </p>

                    {/* <h4 className="fw-bold">Bank Details</h4>

                    <div className="col-5">
                      <table className="table">
                        <tr>
                          <th>Bank Name : </th>
                          <td>Indusind Bank Ltd. </td>
                        </tr>
                        <tr>
                          <th>Branch Name :</th>
                          <td>Jetulpur Rd. Branch </td>
                        </tr>
                        <tr>
                          <th>Account Name :</th>
                          <td>Zithas Technologies Pvt. Ltd. </td>
                        </tr>
                        <tr>
                          <th>Account No. :</th>
                          <td>258141122619 </td>
                        </tr>
                        <tr>
                          <th>IFSC Code : </th>
                          <td>INDB0000017 </td>
                        </tr>
                      </table>
                    </div>

                    <div className="mt-2">
                      <h4 className="fw-bold">Terms &amp; Conditions</h4>
                      <p className="mb-0">
                        1. If payment made by crossed cheque in favour of Zithas
                        Technologies Pvt. Ltd.
                      </p>
                      <p className="mb-0">
                        2. If NEFT / RTGS / Online Transfer should be made to
                        given bank details.
                      </p>
                      <p className="mb-0">
                        3. Late payment charges will be applicable.
                      </p>
                    </div> */}
                    <div style={{ pageBreakInside: "avoid" }}>
                      <div className="d-flex justify-content-between">
                        {/* LEFT SIDE */}
                        <div className="col-6 pe-4 border-end border-2 ">
                          <h4 className="fw-bold">Bank Details</h4>

                          <table className="table"
                            style={{
                              verticalAlign: "top",
                              color: "#495057",
                              fontSize: "12px",
                            }}
                          >
                            <tr>
                              <th>Bank Name :</th>
                              <td>{formatData.bankName}</td>
                            </tr>
                            {
                              isIndia &&
                              <tr>
                                <th>Branch Name :</th>
                                <td>{formatData.branchName}</td>
                              </tr>
                            }
                            <tr>
                              <th>Account Name :</th>
                              <td>{formatData.accountName}</td>

                            </tr>
                            <tr>
                              <th>Account No. :</th>
                              <td>{formatData.accountNo}</td>
                            </tr>
                            <tr>
                              <th>
                                {isIndia
                                  ? "IFSC Code"
                                  : "Routing No."}{" "}
                                :{" "}
                              </th>
                              <td>{formatData.ifscCode}</td>
                            </tr>

                            {configure.location.includes(3) && (
                              <tr>
                                <th
                                  className="pt-1"
                                  style={{ verticalAlign: "top" }}
                                >Bank Address :</th>
                                <td>

                                  <pre
                                    className="mb-1 p-0 pt-1"
                                    style={{
                                      fontFamily: "Poppins",
                                      whiteSpace: "pre-wrap",
                                      color: "#495057",
                                      fontSize: '13px'
                                    }}>
                                    {formatData.bankAddress}
                                  </pre>

                                </td>
                              </tr>
                            )}
                          </table>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-6 ps-4">
                          <h4 className="fw-bold">Terms & Conditions</h4>
                          <div style={{ fontSize: '13px' }}
                            className="inv-terms"
                            dangerouslySetInnerHTML={{ __html: formatData.tnc || "<div>N/A</div>" }} />
                          {/* <p className="mb-1 fs-6">
                          1. If payment made by crossed cheque in favour of
                          Zithas Technologies Pvt. Ltd.
                        </p>
                        <p className="mb-1 fs-6">
                          2. NEFT / RTGS / Online Transfer should be made to the
                          given bank details.
                        </p>
                        <p className="mb-0 fs-6">
                          3. Late payment charges will be applicable.
                        </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-4 pe-0 ">
              <div>
                <div className="col-12 ">
                  <button
                    className="btn btn-sm btn-success border-radius me-1"
                    onClick={() => reactToPrintFn()}
                  >
                    <i className="fas fa-print me-1"></i> Print
                  </button>

                  <button
                    className="btn btn-sm btn-secondary border-radius me-1"
                    onClick={() =>
                      onDownloadPdf(
                        setLoading,
                        contentRef,
                        invoiceData?.tax_inv_no.replace(/\//g, "-"),
                        [0, 5, 5, 5],
                      )
                    }
                  >
                    <i className="fas fa-file-download me-1"></i> Downloads
                  </button>

                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-sm btn-red border-radius"
                  >
                    <i className="fas fa-times fs-6 me-1"></i> Cancel
                  </button>
                </div>

                <div className="bg-white p-3 mt-4 shadow">
                  <h5 className="mb-4 text-dark">
                    Invoice Value : {invoiceData?.currency_symbol}{" "}
                    {(Math.floor(parseFloat(invoiceData?.total || 0) * 100) / 100).toFixed(2)}
                  </h5>

                  <h6 className="mb-3">
                    Invoice Number: {invoiceData?.tax_inv_no}
                  </h6>
                  {moment(invoiceData?.start_date)?.isValid() ? (
                    <h6 className="mb-3">
                      Start Date:{" "}
                      {moment(invoiceData?.start_date).format("DD-MM-YYYY")}
                    </h6>
                  ) : null}
                  {moment(invoiceData?.end_date)?.isValid() ? (
                    <h6 className="mb-3">
                      End Date:{" "}
                      {moment(invoiceData?.end_date).format("DD-MM-YYYY")}
                    </h6>
                  ) : null}
                  <h6 className="mb-3">
                    Due Date:{" "}
                    {moment(invoiceData?.due_date).format("DD-MM-YYYY")}
                  </h6>
                  {invoiceData?.exchange_rate ? (
                    <div className="pt-3 mt-1 border-top">
                      <h6 className="mb-2 text-danger">
                        Exchange Rate :{" "}
                        <span className="fw-normal">
                          1 {invoiceData.currency_symbol} = ₹{" "}
                          {Number(invoiceData.exchange_rate).toFixed(2)}
                        </span>
                      </h6>
                      <h6 className="mb-0 fw-bold">
                        Total (₹) :{" "}
                        <span className="fw-normal">
                          ₹{" "}
                          {(
                            parseFloat(invoiceData.total || 0) *
                            parseFloat(invoiceData.exchange_rate)
                          ).toFixed(2)}
                        </span>
                      </h6>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewZtplInvoice;
